import React from "react";
import { LoadingButton } from "../Common/Loading";

const Guest = () => {
  return (
    <>
      <div className="tf-page-title">
        <div className="container-full">
          <div className="heading text-center">Checkout</div>
        </div>
      </div>
      <section className="flat-spacing-11">
        <div className="container">
          <form
            action="https://uat.webykw.com/index.php/guest/submit"
            id="checkout"
            method="post"
            accept-charset="utf-8"
          >
            <div className="tf-page-cart-wrap layout-2">
              <div className="tf-page-cart-item">
                <h5 className="fw-5 mb_15">Billing Details</h5>
                <div className="form-checkout">
                  <div className="tf-page-cart-checkout widget-wrap-checkout">
                    <div className="grid-2">
                      <fieldset className="fieldset">
                        <label htmlFor="chk_fname">First Name *</label>
                        <input type="text" id="chk_fname" name="chk_fname" />
                      </fieldset>
                      <fieldset className="fieldset">
                        <label htmlFor="chk_lname">Last Name *</label>
                        <input type="text" id="chk_lname" name="chk_lname" />
                      </fieldset>
                    </div>
                    <div className="grid-2">
                      <fieldset className="fieldset">
                        <label htmlFor="chk_email">Email *</label>
                        <input type="text" id="chk_email" name="chk_email" />
                      </fieldset>
                      <fieldset className="fieldset">
                        <label htmlFor="chk_phone">Phone Number *</label>
                        <input type="text" id="chk_phone" name="chk_phone" />
                      </fieldset>
                    </div>
                  </div>
                  <input
                    type="radio"
                    name="chk_addr_type"
                    value="Delivery"
                    className="hidden"
                    defaultChecked
                  />
                  <div
                    id="delivery_view"
                    className="tf-page-cart-checkout widget-wrap-checkout mt-3"
                  >
                    <div className="fieldset">
                      <fieldset className="fieldset">
                        <label htmlFor="chk_country">Country *</label>
                        <div className="select-custom">
                          <select
                            className="js-example-basic-single tf-select w-100"
                            id="chk_country"
                            name="chk_country"
                          >
                            <option data-code="+93" value="1">
                              Afghanistan
                            </option>
                            <option selected data-code="+965" value="105">
                              Kuwait
                            </option>
                            <option data-code="+966" value="176">
                              Saudi Arabia
                            </option>
                          </select>
                        </div>
                      </fieldset>
                    </div>
                    <div id="view1" className="widget-wrap-checkout">
                      <div className="fieldset">
                        <fieldset className="fieldset">
                          <label htmlFor="chk_area">Area *</label>
                          <div className="select-custom">
                            <select
                              className="js-example-basic-single tf-select w-100"
                              name="chk_area"
                              id="chk_area"
                              onchange="updatearea(this.value,'2')"
                            >
                              <option value=""></option>
                              <optgroup label="Ahmadi">
                                <option value="57">Abu Halaifa</option>
                                <option value="54">Al - Mahbula</option>
                                <option value="50">Al Ahmadi</option>
                                <option value="116">Al Julayah </option>
                                <option value="74">
                                  Ali Sabah Al-Salim (Om Al-Heiman)
                                </option>
                                <option value="66">Bnedar</option>
                                <option value="117">Dhahr</option>
                                <option value="118">East Al Ahmadi</option>
                                <option value="119">Egaila</option>
                                <option value="69">Fahad Al-Ahmad</option>
                                <option value="60">Fahaheel</option>
                                <option value="120">Fintas</option>
                                <option value="56">Hadiya</option>
                                <option value="68">Jaber Al-Ali</option>
                                <option value="63">Khairan</option>
                                <option value="73">Khairan City</option>
                                <option value="59">Mangaf</option>
                                <option value="121">Mina Abdullah</option>
                                <option value="122">Mina Al Ahmadi</option>
                                <option value="53">Miqwa'</option>
                                <option value="72">Nuwaiseeb</option>
                                <option value="123">Riqqa</option>
                                <option value="71">Sabah Al-Ahmad City </option>
                                <option value="75">
                                  Sabah Al-Ahmad Nautical City
                                </option>
                                <option value="58">Sabahiya</option>
                                <option value="70">Shu'aiba</option>
                                <option value="65">Wafra Farms</option>
                                <option value="61">Wafra Residential</option>
                              </optgroup>
                              <optgroup label="Al-Asimah">
                                <option value="16">Abdullah Al-Salim</option>
                                <option value="21">Adailiya</option>
                                <option value="13">Bneid Al-Qar</option>
                                <option value="8">Da'iya</option>
                                <option value="7">Dasma</option>
                                <option value="5">Dasman</option>
                                <option value="32">Doha</option>
                                <option value="18">Faiha'</option>
                                <option value="29">Ghirnata</option>
                                <option value="34">Jaber Al-Ahmad</option>
                                <option value="14">Kaifan </option>
                                <option value="22">Khaldiya</option>
                                <option value="101">Kuwait City</option>
                                <option value="15">Mansuriya</option>
                                <option value="10">Mirgab</option>
                                <option value="102">Mubarakiya Camps</option>
                                <option value="33">Nahdha</option>
                                <option value="17">Nuzha</option>
                                <option value="23">Qadsiya</option>
                                <option value="35">Qairawan</option>
                                <option value="103">Qibla</option>
                                <option value="24">Qortuba</option>
                                <option value="28">Rai</option>
                                <option value="20">Rawdha</option>
                                <option value="12">Salhiya</option>
                                <option value="9">Sawabir</option>
                                <option value="19">Shamiya</option>
                                <option value="6">Sharq</option>
                                <option value="27">Shuwaikh</option>
                                <option value="31">Sulaibikhat</option>
                                <option value="25">Surra</option>
                                <option value="26">Yarmouk</option>
                              </optgroup>
                              <optgroup label="Hawalli">
                                <option value="43">Al-Bedea'</option>
                                <option value="93">AlSalam</option>
                                <option value="106">AlSiddiq</option>
                                <option value="42">Bayan</option>
                                <option value="36">Hawally</option>
                                <option value="49">Hiteen</option>
                                <option value="38">Jabriya</option>
                                <option value="46">Maidan Hawally</option>
                                <option value="40">Mishrif</option>
                                <option value="105">
                                  Mubarak Al-Abdullah (West Mishref)
                                </option>
                                <option value="37">Rumaithiya</option>
                                <option value="39">Salmiya</option>
                                <option value="45">Salwa</option>
                                <option value="41">Sha'ab</option>
                                <option value="92">Shuhad'a</option>
                                <option value="95">Zahra'a</option>
                              </optgroup>
                              <optgroup label="Farwaniyah">
                                <option value="107">Abbasiya</option>
                                <option value="84">Abdullah Al Mubarak</option>
                                <option value="76">Abraq Khaitan</option>
                                <option value="108">Airport</option>
                                <option value="109">Andalous</option>
                                <option value="78">Ardhiya</option>
                                <option value="110">Ashbeliah</option>
                                <option value="111">Dhajeej</option>
                                <option value="112">Farwaniyah</option>
                                <option value="80">Ferdous</option>
                                <option value="79">Industrial Ardiya</option>
                                <option value="88">Jleeb Al-Shuyoukh</option>
                                <option value="113">Khaitan</option>
                                <option value="47">Mubarak Al-Jaber</option>
                                <option value="77">Omairiya</option>
                                <option value="83">Rabiya</option>
                                <option value="114">Regg'ai</option>
                                <option value="82">Rehab</option>
                                <option value="89">Sabah Al-Nasser</option>
                                <option value="81">Shadadiya</option>
                                <option value="115">
                                  Sheik Saad Al-Abdullah Airport
                                </option>
                                <option value="86">South Khaitan</option>
                              </optgroup>
                              <optgroup label="Mubarak Al-Kabir">
                                <option value="96">Abu Fatera </option>
                                <option value="99">Adan</option>
                                <option value="137">Al Masayel</option>
                                <option value="138">Al-Qusour</option>
                                <option value="91">Funaitees</option>
                                <option value="97">Messila</option>
                                <option value="100">Mubarak Al-Kabeer </option>
                                <option value="98">Qurain</option>
                                <option value="140">Sabah Al-Salem</option>
                                <option value="141">Sabhan Industrial</option>
                              </optgroup>
                              <optgroup label="Jahra">
                                <option value="124">Al Naeem</option>
                                <option value="125">Amgarah Industrial</option>
                                <option value="87">Jahra</option>
                                <option value="126">Kabd</option>
                                <option value="127">Naseem</option>
                                <option value="128">Oyoun</option>
                                <option value="129">Qasr</option>
                                <option value="130">Saad Al Abdullah</option>
                                <option value="131">Sulaibiya</option>
                                <option value="132">
                                  Sulaibiya Industrial 1
                                </option>
                                <option value="133">
                                  Sulaibiya Industrial 2
                                </option>
                                <option value="135">Tima</option>
                                <option value="136">Waha</option>
                              </optgroup>
                            </select>
                          </div>
                        </fieldset>
                      </div>
                      <div className="fieldset">
                        <fieldset className="fieldset">
                          <label htmlFor="chk_street">
                            Block, Street Number *
                          </label>
                          <input
                            autoComplete="off"
                            type="text"
                            id="chk_street"
                            name="chk_street"
                          />
                        </fieldset>
                      </div>
                      <div className="fieldset">
                        <fieldset className="fieldset">
                          <label htmlFor="chk_house">
                            House, Building, Apartment Number *
                          </label>
                          <input
                            autoComplete="off"
                            type="text"
                            id="chk_house"
                            name="chk_house"
                          />
                        </fieldset>
                      </div>
                    </div>
                    <div id="view2" className="widget-wrap-checkout hidden">
                      <div className="grid-2">
                        <fieldset className="fieldset">
                          <label htmlFor="state">State *</label>
                          <input
                            autoComplete="off"
                            type="text"
                            id="chk_state"
                            name="chk_state"
                          />
                        </fieldset>
                        <fieldset className="fieldset">
                          <label htmlFor="chk_city">City *</label>
                          <input
                            autoComplete="off"
                            type="text"
                            id="chk_city"
                            name="chk_city"
                          />
                        </fieldset>
                      </div>
                      <div className="fieldset">
                        <fieldset className="fieldset">
                          <label htmlFor="chk_address">Address *</label>
                          <input
                            autoComplete="off"
                            type="text"
                            id="chk_address"
                            name="chk_address"
                          />
                        </fieldset>
                      </div>
                      <div className="grid-2">
                        <fieldset className="fieldset">
                          <label htmlFor="address2">Landmark</label>
                          <input
                            autoComplete="off"
                            type="text"
                            id="chk_address2"
                            name="chk_address2"
                          />
                        </fieldset>
                        <fieldset className="fieldset">
                          <label htmlFor="chk_pincode">Pincode *</label>
                          <input
                            autoComplete="off"
                            type="text"
                            id="chk_pincode"
                            name="chk_pincode"
                          />
                        </fieldset>
                      </div>
                    </div>
                  </div>
                  <div
                    id="pickup_view"
                    className="tf-page-cart-checkout widget-wrap-checkout mt-3 hidden"
                  >
                    <div className="grid-1">
                      <label htmlFor="branch">Branch *</label>
                      <div className="select-custom">
                        <select
                          className="tf-select w-100"
                          id="chk_branch"
                          name="chk_branch"
                          onchange="changeaddress()"
                        >
                          <option value="">Select</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="tf-page-cart-checkout widget-wrap-checkout mt-3">
                    <div className="wd-check-payment">
                      <div className="fieldset-radio">
                        <input
                          type="radio"
                          className="tf-check"
                          name="delivery_timing"
                          value="1"
                          id="del"
                          checked="checked"
                        />
                        <label htmlFor="del">
                          Your order would be delivered in{" "}
                          <span id="del_time">Selected Country / Area</span>
                        </label>
                        <input
                          type="hidden"
                          name="delivery_time"
                          id="delivery_time"
                          value=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="tf-page-cart-footer">
                <div className="tf-cart-footer-inner">
                  <h5 className="fw-5 mb_15">Your Order</h5>
                  <div className="tf-page-cart-checkout widget-wrap-checkout">
                    <ul className="wrap-checkout-product">
                      <li className="checkout-product-item">
                        <figure className="img-product">
                          <img
                            src="https://imgcdn.webykw.com/cdn-cgi/image/fit=cover,width=80,height=110/lolia/products/1726330315_b964d4dba25069fb.jpg"
                            alt="product"
                          />
                          <span className="quantity">1</span>
                        </figure>
                        <div className="content">
                          <div className="info">
                            <p className="name">V-Neck Cardigan</p>
                            <span className="variant">
                              Color: Off-White
                              <br />
                              Size: XS
                              <br />
                              Add Length Details: 1<br />
                            </span>
                          </div>
                          <span className="price">KWD 10.410</span>
                        </div>
                      </li>
                      <li className="checkout-product-item">
                        <figure className="img-product">
                          <img
                            src="https://imgcdn.webykw.com/cdn-cgi/image/fit=cover,width=80,height=110/lolia/products/1726330311_d4c1288716e63e0b.jpg"
                            alt="product"
                          />
                          <span className="quantity">1</span>
                        </figure>
                        <div className="content">
                          <div className="info">
                            <p className="name">
                              Dolce & Gabbana Velvet Black Patchouli
                            </p>
                            <span className="variant">
                              Select Option: 100ML
                              <br />
                            </span>
                          </div>
                          <span className="price">KWD 120.750</span>
                        </div>
                      </li>
                    </ul>
                    <div id="discount_str">
                      <div className="coupon-box" id="discount_str">
                        <input
                          type="text"
                          id="coupon_redeem"
                          placeholder="Coupon Code"
                        />
                        <button
                          type="button"
                          className="tf-btn btn-sm radius-3 btn-fill btn-icon animate-hover-btn"
                        >
                          Apply
                        </button>
                      </div>
                      <p className="error" id="coupon_err"></p>
                    </div>
                    <div className="d-flex justify-content-between line pb-2">
                      <h6 className="lg_fs_16">Sub Total</h6>
                      <h6 className="lg_fs_16 total">KWD 131.160</h6>
                    </div>
                    <div className="d-flex justify-content-between line pb-2">
                      <h6 className="lg_fs_16">Discount (-)</h6>
                      <h6 className="lg_fs_16 total">
                        <span id="discount">KWD 0.000</span>
                      </h6>
                    </div>
                    <div className="d-flex justify-content-between line pb-2">
                      <h6 className="lg_fs_16">
                        <span className="del_tit">Delivery</span>
                        Charges (+)
                      </h6>
                      <h6 className="lg_fs_16 total">
                        <span id="delivery_charges">KWD 0.000</span>
                      </h6>
                    </div>
                    <div className="d-flex justify-content-between line pb-2 ">
                      <h6 className="lg_fs_16">Gift Wrap (+)</h6>
                      <h6 className="lg_fs_16 total">
                        <span id="gift_wrap">KWD 1.000</span>
                      </h6>
                    </div>
                    <div className="d-flex justify-content-between line pb-4">
                      <h6 className="fw-5">Total Price</h6>
                      <h6 className="total fw-5">
                        <span id="grand">KWD 132.160</span>
                      </h6>
                    </div>
                    <div className="wd-check-payment ">
                      <div className="fieldset-radio mb_15">
                        <input
                          type="radio"
                          className="tf-check"
                          name="chk_payment"
                          id="link"
                          value="Pay by Link"
                          defaultChecked
                        />
                        <label htmlFor="link">Pay by Link</label>
                      </div>
                      <div className="fieldset-radio mb_15" id="cod_view">
                        <input
                          type="radio"
                          className="tf-check"
                          name="chk_payment"
                          id="cod"
                          value="COD"
                        />
                        <label htmlFor="cod">Cash on Delivery</label>
                      </div>
                    </div>
                    <div className="wd-check-payment hidden">
                      <div className="fieldset-radio" id="chk_terms">
                        <input
                          type="checkbox"
                          name="chk_terms"
                          id="terms"
                          className="tf-check"
                          value="1"
                          checked
                        />{" "}
                        <label htmlFor="terms">
                          Please accept{" "}
                          <a href="#termsConditions" data-bs-toggle="modal">
                            Terms & Conditions
                          </a>
                        </label>
                      </div>
                    </div>
                    <button
                      className="tf-btn radius-3 btn-fill btn-icon animate-hover-btn justify-content-center"
                      id="placeorder"
                    >
                      {/* {loading ? <LoadingButton></LoadingButton> : ""} */}
                      PLACE ORDER{" "}
                    </button>
                    <button id="continue" style={{ display: "none" }}></button>
                  </div>
                </div>
              </div>
            </div>
          </form>{" "}
        </div>
      </section>
    </>
  );
};

export default Guest;
